import PropTypes from 'prop-types';
import FJHoverBoardGradation from '../../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import FJTextToImageDataConfig from '../../../../config/dataConfig/FJTextToImageDataConfig';
import styles from './FJTextToImageModels.module.less';
import FJLocalStore from '../../../../store/FJLocalStore';
import classNames from 'classnames';

const FJTextToImageModels = ({ curModel, onChange }) => {
    const curModelObj = FJTextToImageDataConfig.MODELS.find(item => item.value === curModel);

    return (
        <div className={styles.models_box}>
            <div className={styles.models_title}>{FJLocalStore._('models')}</div>
            <div className={styles.models_list_box}>
                {FJTextToImageDataConfig.MODELS.map((item, index) => {
                    return (
                        <FJHoverBoardGradation
                            key={index}
                            active={curModelObj.name === item.name}
                            className={classNames(styles.models_board_gradation, {
                                [styles.models_board_gradation_hover]: !(curModelObj.name === item.name),
                            })}
                            contentClassName={styles.models_item}
                            onClick={() => onChange && onChange(item)}
                        >
                            <item.icon />
                            <div className={styles.models_name}>{FJLocalStore._(item.name)}</div>
                        </FJHoverBoardGradation>
                    );
                })}
            </div>
        </div>
    );
};

FJTextToImageModels.propTypes = {
    curModel: PropTypes.string,
    onChange: PropTypes.func,
};

export default FJTextToImageModels;
